/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { SalesTeam } from './SalesTeam';
import {
    SalesTeamFromJSON,
    SalesTeamFromJSONTyped,
    SalesTeamToJSON,
    SalesTeamToJSONTyped,
} from './SalesTeam';
import type { InvoiceAddress } from './InvoiceAddress';
import {
    InvoiceAddressFromJSON,
    InvoiceAddressFromJSONTyped,
    InvoiceAddressToJSON,
    InvoiceAddressToJSONTyped,
} from './InvoiceAddress';
import type { MediaLinks } from './MediaLinks';
import {
    MediaLinksFromJSON,
    MediaLinksFromJSONTyped,
    MediaLinksToJSON,
    MediaLinksToJSONTyped,
} from './MediaLinks';

/**
 * 
 * @export
 * @interface RetailerDetails
 */
export interface RetailerDetails {
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    id: string;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof RetailerDetails
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    companyName: string;
    /**
     * 
     * @type {InvoiceAddress}
     * @memberof RetailerDetails
     */
    invoiceAddress: InvoiceAddress;
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    vatId: string;
    /**
     * 
     * @type {Date}
     * @memberof RetailerDetails
     */
    customerSince: Date;
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    phoneNumber: string;
    /**
     * 
     * @type {RetailerDetailsBusinessTypeEnum}
     * @memberof RetailerDetails
     */
    businessType: RetailerDetailsBusinessTypeEnum;
    /**
     * 
     * @type {MediaLinks}
     * @memberof RetailerDetails
     */
    mediaLinks: MediaLinks;
    /**
     * 
     * @type {string}
     * @memberof RetailerDetails
     */
    productExportLink: string;
    /**
     * 
     * @type {SalesTeam}
     * @memberof RetailerDetails
     */
    salesTeam: SalesTeam;
}


/**
 * @export
 */
export const RetailerDetailsBusinessTypeEnum = {
    Store: 'STORE',
    Wholesale: 'WHOLESALE',
    Ecommerce: 'ECOMMERCE',
    StoreAndEcommerce: 'STORE_AND_ECOMMERCE',
    Other: 'OTHER'
} as const;
export type RetailerDetailsBusinessTypeEnum = typeof RetailerDetailsBusinessTypeEnum[keyof typeof RetailerDetailsBusinessTypeEnum];


/**
 * Check if a given object implements the RetailerDetails interface.
 */
export function instanceOfRetailerDetails(value: object): value is RetailerDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('invoiceAddress' in value) || value['invoiceAddress'] === undefined) return false;
    if (!('vatId' in value) || value['vatId'] === undefined) return false;
    if (!('customerSince' in value) || value['customerSince'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('businessType' in value) || value['businessType'] === undefined) return false;
    if (!('mediaLinks' in value) || value['mediaLinks'] === undefined) return false;
    if (!('productExportLink' in value) || value['productExportLink'] === undefined) return false;
    if (!('salesTeam' in value) || value['salesTeam'] === undefined) return false;
    return true;
}

export function RetailerDetailsFromJSON(json: any): RetailerDetails {
    return RetailerDetailsFromJSONTyped(json, false);
}

export function RetailerDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'companyName': json['companyName'],
        'invoiceAddress': InvoiceAddressFromJSON(json['invoiceAddress']),
        'vatId': json['vatId'],
        'customerSince': (new Date(json['customerSince'])),
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'businessType': json['businessType'],
        'mediaLinks': MediaLinksFromJSON(json['mediaLinks']),
        'productExportLink': json['productExportLink'],
        'salesTeam': SalesTeamFromJSON(json['salesTeam']),
    };
}

export function RetailerDetailsToJSON(json: any): RetailerDetails {
    return RetailerDetailsToJSONTyped(json, false);
}

export function RetailerDetailsToJSONTyped(value?: RetailerDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'companyName': value['companyName'],
        'invoiceAddress': InvoiceAddressToJSON(value['invoiceAddress']),
        'vatId': value['vatId'],
        'customerSince': value['customerSince'].toISOString(),
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'businessType': value['businessType'],
        'mediaLinks': MediaLinksToJSON(value['mediaLinks']),
        'productExportLink': value['productExportLink'],
        'salesTeam': SalesTeamToJSON(value['salesTeam']),
    };
}

